export const getZipFiles = (state) => state.file.zipFiles;
